// Simple browser-compatible event emitter
export class BrowserEventEmitter {
  private events: Record<string, Array<(data: any) => void>> = {};

  on(event: string, listener: (data: any) => void): () => void {
    if (!this.events[event]) {
      this.events[event] = [];
    }

    this.events[event].push(listener);

    return () => this.off(event, listener);
  }

  off(event: string, listener: (data: any) => void): void {
    if (!this.events[event]) return;

    this.events[event] = this.events[event].filter((l) => l !== listener);
  }

  emit(event: string, data?: any): void {
    if (!this.events[event]) return;

    this.events[event].forEach((listener) => listener(data));
  }

  removeAllListeners(): void {
    this.events = {};
  }
}
